import { render, staticRenderFns } from "./AssetDetailsActivity.vue?vue&type=template&id=206f37e8&scoped=true&"
import script from "./AssetDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f37e8",
  null
  
)

export default component.exports